import React from 'react';
import { PropTypes } from 'prop-types';
import Input from '../widgets/Input';
import { Button } from '@progress/kendo-react-buttons';

const LoginForm = ({
    onSubmit,
    onForgotPassword,
    onChange,
    errors,
    onSignIn,
    user
}) => (
        
            <div className="login-container">
            
                <div className="panel panel-default">

                    <div className="panel-heading">
                        <img src="/assets/Images/Logo_2.png" />
                        <span>Please enter your user information</span>
                        <div className="login-heading-divider"></div>
                    </div>
                    <div className="panel-body">
                    <form>

                        <div className="form-login">
                            
                            <div className="login-field-wrap">
                                <span className="mdi mdi-domain login-field-icon"></span>
                                <Input props={{label:'Client'}} value={user.client}  type='text' name='client' error={errors.client} onChange={onChange} />
                            </div>
                            <div className="login-field-wrap">
                                <span className="mdi mdi-account login-field-icon"></span>
                                <Input props={{label:'Username'}} value={user.email} type='text' name='email' error={errors.email} onChange={onChange}  />
                            </div>
                            <div className="login-field-wrap">
                                <span className="mdi mdi-lock-outline login-field-icon"></span>
                                <Input props={{label:'Password'}} value={user.password} type='password' name='password' error={errors.password} onChange={onChange}  />
                            </div>

                            <div className="top-40">
                                <Button style={{width: '100%', height: 50, fontSize: '16px', borderRadius: '8px'}} name='btnLogin' themeColor={'primary'} onClick={onSubmit}>
                                    <span className="mdi mdi-login" style={{marginRight: 8}}></span>Log in
                                </Button>
                                <div className="g-signin2" onClick={onSignIn}></div>                    
                            </div> 
                            <div className="top-40">
                                <a className="login-forgot-link" href='#' onClick={onForgotPassword}>Forgot Password</a>                        
                            </div>

                            <div className="login-footer">&copy; Checkpoint 2026</div>

                        </div>
                    </form>
                    </div>
                </div>

            </div>

    );

LoginForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
};

export default LoginForm;